import { render, staticRenderFns } from "./WorkflowTemplatesPage.vue?vue&type=template&id=3efe6cde&scoped=true"
import script from "./WorkflowTemplatesPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./WorkflowTemplatesPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./WorkflowTemplatesPage.vue?vue&type=style&index=0&id=3efe6cde&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efe6cde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3efe6cde')) {
      api.createRecord('3efe6cde', component.options)
    } else {
      api.reload('3efe6cde', component.options)
    }
    module.hot.accept("./WorkflowTemplatesPage.vue?vue&type=template&id=3efe6cde&scoped=true", function () {
      api.rerender('3efe6cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Pages/WorkflowTemplates/Components/WorkflowTemplatesPage.vue"
export default component.exports